import React, { useEffect, useState } from "react";
import { request } from "../../../../utils/Request";

const AlpFreezeStatusNotice = () => {
    const [message, setMessage] = useState<string | null>(null);

    useEffect(() => {
        let isMounted = true;

        const fetchFreezeStatus = async () => {
            try {
                const response = await request({
                    url: "/providers/emil/frey/freeze/status",
                    method: "GET",
                });

                const data = response?.data?.data || {};
                const isFreezed = Boolean(data?.is_freezed);
                const freezeMessage = typeof data?.message === "string" ? data.message : null;

                if ( isMounted ) {
                    setMessage(isFreezed ? freezeMessage : null);
                }
            } catch (e) {
                if ( isMounted ) {
                    setMessage(null);
                }
            }
        };

        fetchFreezeStatus();

        return () => {
            isMounted = false;
        };
    }, []);

    if ( !message ) {
        return null;
    }

    return (
        <div className="text-danger">
            { message }
        </div>
    );
};

export default AlpFreezeStatusNotice;
